export const layoutForms = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 16,
  },
};

export const toEnglishDigits = (str) => {
  // convert persian digits [۰۱۲۳۴۵۶۷۸۹]
  if (!str) return "";
  try {
    var e = "۰".charCodeAt(0);
    str = str.replace(/[۰-۹]/g, function (t) {
      return t.charCodeAt(0) - e;
    });

    // convert arabic indic digits [٠١٢٣٤٥٦٧٨٩]
    e = "٠".charCodeAt(0);
    str = str.replace(/[٠-٩]/g, function (t) {
      return t.charCodeAt(0) - e;
    });
  } catch {}
  return str;
};

export const TypeList = [
  { title: "پوسیدگی", value: "caries", color: "#24075070" },
  { title: "آمالگام", value: "amalgam", color: "#344C6470" },
  { title: "کامپوزیت", value: "composite", color: "#57A6A170" },
  { title: "فیشور سیلانت", value: "fisureSilant", color: "#83B4FF70" },
  { title: "ترمیم ناقص", value: "notCompleteRestorative", color: "#F075AA70" },
  { title: "Crown", value: "crown", color: "#FDFFE270" },
  { title: "اپلاینس ارتودنسی ", value: "ortho", color: "#A1DD7070" },
  { title: "جرم", value: "calculus", color: "#ECB17670" },
  { title: "stain", value: "stain", color: "#6F4E3770" },
  // { title: "سالم", value: "healthy" },
];

export const TypeName = (value) => {
  let obj = TypeList.find((o) => o.value == value);

  return obj?.title;
};

export const calculateSignedAngle = (pointA, pointB, pointC) => {
  const vectorAB = { x: pointB.x - pointA.x, y: pointB.y - pointA.y };
  const vectorBC = { x: pointC.x - pointB.x, y: pointC.y - pointB.y };

  const dotProduct = vectorAB.x * vectorBC.x + vectorAB.y * vectorBC.y;
  const crossProduct = vectorAB.x * vectorBC.y - vectorAB.y * vectorBC.x;

  const magnitudeAB = Math.sqrt(vectorAB.x ** 2 + vectorAB.y ** 2);
  const magnitudeBC = Math.sqrt(vectorBC.x ** 2 + vectorBC.y ** 2);

  let acosTeta = dotProduct / (magnitudeAB * magnitudeBC);

  // Ensure acosTeta is within the valid range [-1, 1]
  acosTeta = Math.max(-1, Math.min(1, acosTeta));

  let tettaRad = Math.acos(acosTeta);

  // Determine the sign of the angle based on the cross product
  if (crossProduct < 0) {
    tettaRad = -tettaRad;
  }

  // Convert angle to degrees
  let tetaDegree = tettaRad * (180 / Math.PI);

  if (tetaDegree < 0) {
    tetaDegree = 180 + tetaDegree;
  } else {
    tetaDegree = tetaDegree - 180;
  }

  return tetaDegree;
};

export const calculateAngle = (pointA, pointB, pointC) => {
  let dAB = calculateDistance(pointA, pointB);
  let dAC = calculateDistance(pointA, pointC);
  let dBC = calculateDistance(pointB, pointC);
  let acosTeta = (dAB ** 2 + dBC ** 2 - dAC ** 2) / (2 * dAB * dBC);
  let tettaRad = Math.acos(acosTeta);
  let tetaDegree = tettaRad * (180 / Math.PI);
  return tetaDegree;
};

export const calculateDistance = (point1, point2) => {
  const dx = point2.x - point1.x;
  const dy = point2.y - point1.y;
  return Math.sqrt(dx * dx + dy * dy);
};

export const calculateAngleBetweenLines = (pointA, pointB, pointC, pointD) => {
  // Calculate the vectors AB and CD
  let vectorAB = { x: pointB.x - pointA.x, y: pointB.y - pointA.y };
  let vectorCD = { x: pointD.x - pointC.x, y: pointD.y - pointC.y };

  // Calculate the dot product of AB and CD
  let dotProduct = vectorAB.x * vectorCD.x + vectorAB.y * vectorCD.y;

  // Calculate the magnitudes of AB and CD
  let magnitudeAB = Math.sqrt(vectorAB.x ** 2 + vectorAB.y ** 2);
  let magnitudeCD = Math.sqrt(vectorCD.x ** 2 + vectorCD.y ** 2);

  // Calculate the angle between the vectors using the dot product formula
  let cosTheta = dotProduct / (magnitudeAB * magnitudeCD);
  let thetaRad = Math.acos(cosTheta);
  let thetaDegree = thetaRad * (180 / Math.PI);
  return thetaDegree;
};

export const getCroppedImg = (imageSrc, pixelCrop) => {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.src = imageSrc;
    image.crossOrigin = "anonymous";
    image.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = pixelCrop.width;
      canvas.height = pixelCrop.height;
      const ctx = canvas.getContext("2d");

      ctx.drawImage(
        image,
        pixelCrop.x,
        pixelCrop.y,
        pixelCrop.width,
        pixelCrop.height,
        0,
        0,
        pixelCrop.width,
        pixelCrop.height
      );

      canvas.toBlob((blob) => {
        if (!blob) {
          reject(new Error("Canvas is empty"));
          return;
        }
        resolve(blob);
      }, "image/jpeg");
    };

    image.onerror = (error) => {
      reject(error);
    };
  });
};
